import {combineReducers, configureStore } from '@reduxjs/toolkit'
import {persistReducer, persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER} from "redux-persist";
import storageSession from 'redux-persist/lib/storage/session';
import storage from 'redux-persist/lib/storage'
import authReducer from './slice/authSlice'
import categoryReducer from './slice/categorySlice'
import paymentReducer from './slice/paymentSlice'
import errorReportReducer from './slice/errorReportSlice'
import pricingReducer from './slice/pricingSlice'
import {errorReset, sessionTimeOutReset} from "./setup/cleanup";

const localPersistConfig = {
    key: 'local',
    storage,
    transforms: [errorReset, sessionTimeOutReset]
}

const sessionPersistConfig = {
    key: 'session',
    storage: storageSession,
    transforms: [errorReset],
    whitelist: ['category']
};


const sessionReducer = combineReducers({
    category: categoryReducer,
    payment: paymentReducer,
    errorReport: errorReportReducer,
    pricing: pricingReducer,
})

const localReducer = combineReducers({
    auth: authReducer
})

const sessionPersistedReducer = persistReducer(sessionPersistConfig, sessionReducer);
const localPersistedReducer = persistReducer(localPersistConfig, localReducer);

const persistedReducer = combineReducers({
    session: sessionPersistedReducer,
    local: localPersistedReducer
})

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
});


export const persistor = persistStore(store);
